import { infoIcon } from "../../../assets/icons";

const Tooltip = ({ message, children, shouldShow, position = "top-10" }) => {
  return (
    <>
      {children ? (
        <div className="group relative flex">
          {children}
          {shouldShow && (
            <span
              className={`${position} absolute whitespace-nowrap z-[800] scale-0 transition-all rounded bg-gray-800 p-2 text-xs text-white group-hover:scale-100`}
            >
              {message}
            </span>
          )}
        </div>
      ) : (
        <div className="tooltip">
          <span className="hover:text-gray-400 font-medium">
            <img src={infoIcon} alt="info" className="w-4 h-4 ml-1" />
          </span>
          <div className="p-4 bg-white w-60 h-90 rounded-md z-20 absolute right-0 invisible tooltip-item ">
            <span className="font-sm text-black pb-4">{message}</span>
          </div>
        </div>
      )}
    </>
  );
};

export default Tooltip;
